import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./sidebar.css";
import { hostInfo } from '../server';

const Sidebar = ({ database }) => {
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [showNotSuccessNotification, setShowNotSuccessNotification] =
    useState(false);
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(hostInfo + "/blogget/")
      .then((res) => res.json())
      .then((data) => {
        setBlogs([...data].reverse());
      })
      .catch((error) => console.error("Error fetching blogs:", error));
  }, []);  

  const handleBlogClick = (blog) => {
 
    setSelectedBlog(blog);
    navigate(`/dashbord/${blog.ID}`, { state: { database: database } });
  };

  const handleAddBlogClick = () => {
    const newBlog = {
      id: blogs.length + 1,  // You can replace this with the real ID from the backend
      title: `New Blog ${blogs.length + 1}`,
      content: "This is the content of the new blog.",
    };

    // Prepend the new blog to the blogs array
    setBlogs([newBlog, ...blogs]);

    // Navigate to the blog creation page
    navigate(`/dashboard/addblog`, { state: { database: database } });
    window.location.reload();
  };

  const onDeleteBlog = (blogId) => {
    fetch(hostInfo + `/blog/${blogId}`, {
      method: "DELETE",
    })
      .then(() => {
        setBlogs((prevBlogs) => prevBlogs.filter((blog) => blog.id !== blogId));
        setShowSuccessNotification(true);
        setTimeout(() => setShowSuccessNotification(false), 3000);
      })
      .catch((error) => {
        console.error("Error deleting blog:", error);
        setShowNotSuccessNotification(true);
        setTimeout(() => setShowNotSuccessNotification(false), 3000);
      });
  };

  const updateBlogs = (newBlog) => {
    setBlogs((prevBlogs) => [...prevBlogs, newBlog]);
  };

  return (
    <div className="sidebar">
      <div
        style={{
          margin: "-20px 10px",
          justifyContent: "space-around",
          display: "flex",
        }}
      >
        <span style={{ cursor: "pointer" }}>
          <h3>Blog List</h3>
        </span>
        <span>
          <h3>|</h3>
        </span>
        <span>
          <h4>{database}</h4>
        </span>
      </div>

      <ul>
        {blogs &&
          blogs.length > 0 &&
          blogs.map((blog) => (
            <div
              key={blog.id}
              style={{ display: "flex", alignItems: "center" }}
            >
              <li style={{ flex: 1 }}>
                <span
                  style={{ cursor: "pointer", margin: "-5px 0px" }}
                  onClick={() => handleBlogClick(blog)}
                >
                  {blog && blog.title && blog.title.length > 30
                    ? blog.title.slice(0, 20) + "..."
                    : (blog && blog.title) || ""}
                </span>
              </li>
              <div
                style={{
                  gap: "5px",
                  display: "flex",
                  paddingLeft: "8px",
                  alignItems: "center",
                }}
              >
                <svg
                  fill="none"
                  height="20"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => handleBlogClick(blog)}
                >
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                <svg
                  height="20"
                  width="20"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => onDeleteBlog(blog.ID)}
                  style={{ cursor: "pointer", fill: "black" }}
                >
                  <path d="M3 6l3 18h12l3-18H3zm16 0l-1.5-2H6L4.5 6H19z" />
                </svg>
              </div>
            </div>
          ))}
      </ul>

      <button onClick={handleAddBlogClick}>Add Blog</button>

      {showSuccessNotification && (
        <div className="notification">Data deleted successfully!</div>
      )}
      {showNotSuccessNotification && (
        <div className="notification1">Data not deleted successfully!</div>
      )}

      {/ Display selected blog details /}
      {selectedBlog && (
        <div className="blog-details">
          <h2>{selectedBlog.title}</h2>
          <p>{selectedBlog.content}</p>
        </div>
      )}
    </div>
  );
};

export default Sidebar;